import { Drawer, Menu } from 'antd';
import MenuItem from 'antd/lib/menu/MenuItem';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import companyLogo from '../../assets/images/logo.svg';
import userAvatar from '../../assets/images/mobile-user-avatar.svg';
import { theme } from '../ui/themes/default';

export const MobileNavbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: ${theme.mediumGreyA};
`;

export const MobileNavbarLogo = styled.div`
  background: url(${companyLogo});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 190px;
  height: 40px;
`;

export const MobileNavbarActions = styled.div`
  display: flex;
  gap: 12px;
  .ant-btn {
    width: 40px;
    height: 40px;
  }
`;

export const MobileNavbarAvatar = styled.div<{ imageUrl?: string; expanded?: boolean }>`
  background: url(${({ imageUrl }) => imageUrl || userAvatar});
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${theme.secondary} !important;
`;

export const PhoneLink = styled.a`
  display: flex;

  > span {
    color: ${theme.primary};
    text-decoration: underline;
  }
`;

export const MenuLabel = styled.span`
  font-weight: 600;
  font-size: 16px;
`;

export const StyledMenuItem = styled(MenuItem)<{ active?: boolean }>`
  height: 64px !important;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  padding: 0 16px;
  border-radius: 8px;

  > span {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: ${theme.menuActiveItemBackground};
  }
`;

export const EmergencySection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  margin: 76px 0 32px;
`;

export const PhoneSection = styled.a`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: ${theme.borderRadioBase};
  justify-content: center;
  height: 64px;
  transition: all ease 0.3s;
`;

export const CloseIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInputSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > span {
    margin-right: 8px;
  }
`;

export const StyledDrawer = styled(Drawer)`
  & .ant-drawer-inline {
    top: 48px;
  }

  & .ant-drawer-body {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  & .ant-drawer-content {
    background: ${theme.lightGrey};
  }

  & .ant-drawer-header {
    display: none;
  }

  & .ant-drawer-content-wrapper {
    box-shadow: none;
  }
`;

export const StyledMenu = styled(Menu)`
  border: none;
  background: ${theme.lightGrey};
`;

export const ProfileMenuItem = styled(MenuItem)`
  display: flex;
  height: 48px;
  align-items: center;
  cursor: pointer;
  padding: 0 !important;

  &:last-child {
    border-top: 1px solid ${theme.grey};
  }
`;

export const ProfileStyledMenu = styled(Menu)`
  padding: 8px;
  border-right: none;
  background: transparent;
`;

export const ProfileStyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 20px;
  color: ${theme.secondary} !important;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const UserSection = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  gap: 12px;
  line-height: 1.7;
`;
